import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useNavigate, useParams } from 'react-router-dom';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import useCurrentProject from '@hooks/useCurrentProject';
import * as commonS from '@styles/common';
import MainContentHeader from '@components/MainContentHeader';
import Wrapper from '@components/Wrapper';
import Loader from '@components/Loader';
import stores from '@stores';

import * as S from './styles';

const StandorteScreen = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { currentProject } = useCurrentProject();
  const [projectBildings, setProjectBildings] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const { projectsStore, dictionariesStore } = stores;
  const { isLoading } = projectsStore;
  const { nursery, juniorSchool, middleSchool } = dictionariesStore;

  const handleSave = async () => {
    await projectsStore.editProject(
      { institutions: projectBildings },
      params.id
    );
    await projectsStore.getProjectsList();
    setDisabled(true);
  };

  const getBuildings = async () => {
    if (currentProject && currentProject.type === 'Nursery') {
      await dictionariesStore.getInstitutionsList('Nursery');
    } else if (currentProject && currentProject.type === 'School') {
      await dictionariesStore.getInstitutionsList('JuniorSchool');
      await dictionariesStore.getInstitutionsList('MiddleSchool');
    }
  };

  const handleBildingCHange = (bildingId: string, checked: boolean) => {
    setDisabled(false);
    if (checked) {
      setProjectBildings([...projectBildings, bildingId]);
    } else {
      const arr = [...projectBildings];
      const index = arr.indexOf(bildingId);
      arr.splice(index, 1);
      setProjectBildings([...arr]);
    }
  };

  useEffect(() => {
    if (currentProject?.type) {
      getBuildings();
      setProjectBildings(currentProject?.institutions);
    }
  }, [currentProject]);

  return (
    <commonS.MainBody>
      {!!currentProject && currentProject.type === 'Nursery' && (
        <>
          <MainContentHeader
            title={currentProject.title}
            buttonTitle="Zu Projekten"
            onButtonClick={() => navigate('/projekte')}
          />
          <Wrapper
            headTitle="Wähle Standorte"
            disabled={disabled}
            onButtonClick={() => handleSave()}
          >
            <div>
              <S.Item>
                <S.ItemTitle>Kindergarten</S.ItemTitle>
                <S.Content>
                  {nursery.length &&
                    nursery.map((e: any) => (
                      <FormControlLabel
                        key={e?._id}
                        control={
                          <Checkbox
                            checked={
                              projectBildings.length
                                ? projectBildings.includes(e?._id)
                                : false
                            }
                            onChange={(item) =>
                              handleBildingCHange(e?._id, item.target.checked)
                            }
                          />
                        }
                        label={e.address}
                      />
                    ))}
                </S.Content>
              </S.Item>
            </div>
            {isLoading && <Loader filled={false} />}
          </Wrapper>
        </>
      )}

      {!!currentProject && currentProject.type === 'School' && (
        <>
          <MainContentHeader
            title={currentProject.title}
            buttonTitle="Zu Projekten"
            onButtonClick={() => navigate('/projekte')}
          />
          <Wrapper
            headTitle="Wähle Standorte"
            disabled={disabled}
            onButtonClick={() => handleSave()}
          >
            <div>
              <S.Item>
                <S.ItemTitle>Unterstufe</S.ItemTitle>
                <S.Content>
                  {juniorSchool.length ? (
                    juniorSchool.map((e: any) => (
                      <FormControlLabel
                        key={e?._id}
                        control={
                          <Checkbox
                            checked={
                              projectBildings.length
                                ? projectBildings.includes(e?._id)
                                : false
                            }
                            onChange={(item) =>
                              handleBildingCHange(e?._id, item.target.checked)
                            }
                          />
                        }
                        label={e.address}
                      />
                    ))
                  ) : (
                    <>Unterstufe not found</>
                  )}
                </S.Content>
              </S.Item>

              <S.Item>
                <S.ItemTitle>Mittelstufe</S.ItemTitle>
                <S.Content>
                  {middleSchool.length ? (
                    middleSchool.map((e: any) => (
                      <FormControlLabel
                        key={e?._id}
                        control={
                          <Checkbox
                            checked={
                              projectBildings.length
                                ? projectBildings.includes(e?._id)
                                : false
                            }
                            onChange={(item) =>
                              handleBildingCHange(e?._id, item.target.checked)
                            }
                          />
                        }
                        label={e.address}
                      />
                    ))
                  ) : (
                    <>Mittelstufe not found</>
                  )}
                </S.Content>
              </S.Item>
            </div>
            {isLoading && <Loader filled={false} />}
          </Wrapper>
        </>
      )}
    </commonS.MainBody>
  );
};

export default observer(StandorteScreen);
